module.exports = __webpack_public_path__ + "static/img/zp.fed3a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zp.jpg
// module id = uDYE
// module chunks = 1